var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlMultiblyOutlined = function SvgHtlMultiblyOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 13a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2Zm0-1h12V4H2v8Zm5.5-1v-.383c-.966-.149-1.625-.728-1.625-1.486a.5.5 0 0 1 1 0c0 .252.43.524 1.125.524.695 0 1.125-.327 1.125-.629s-.4-.525-1.2-.639c-1.355-.193-1.839-.911-1.839-1.518a1.507 1.507 0 0 1 1.409-1.485V5a.5.5 0 0 1 1 0v.386a1.526 1.526 0 0 1 1.41 1.483.5.5 0 0 1-1 0c0-.486-.701-.524-.91-.524-.339 0-.91.068-.91.524 0 .157.261.426.981.529.48.048.946.196 1.366.434a1.363 1.363 0 0 1 .688 1.194 1.74 1.74 0 0 1-1.624 1.587V11a.5.5 0 0 1-.5.5.5.5 0 0 1-.496-.5Z"
  })));
};
export default SvgHtlMultiblyOutlined;